import { render, staticRenderFns } from "./SourceEdit.vue?vue&type=template&id=05a45515&"
import script from "./SourceEdit.vue?vue&type=script&lang=js&"
export * from "./SourceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports